import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

/**
 * Trigger for the recommendations popup (app-new-recomendations). Fired
 * through RecomendationsSwitchService.open() — don't call show.next()
 * directly, use open().
 *
 * The popup's code is loaded lazily (lazy-components.ts): AppComponent
 * mounts it once the app is idle after boot, or straight away when open()
 * comes first (`mount$`). An open() before the popup has subscribed waits
 * for its `ready$` instead of being lost.
 */
@Injectable({
  providedIn: 'root',
})
export class NewRecomendationsService {
  show: Subject<void> = new Subject<void>();

  /** true once the popup should be mounted; AppComponent watches it. */
  mount$ = new BehaviorSubject<boolean>(false);

  /** true while a mounted popup is subscribed to `show`. */
  ready$ = new BehaviorSubject<boolean>(false);

  /** Opens the popup, mounting it first if it isn't yet. */
  open() {
    if (!this.mount$.value) this.mount$.next(true);
    this.ready$
      .pipe(filter(Boolean), take(1))
      .subscribe(() => this.show.next());
  }
}
